import React from 'react';
import HomeDesc from "../components/HomeDesc"
import Button from '../components//Button';
import Grid from '@material-ui/core/Grid';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import bio from "../images/bio.jpeg"
import km from "../images/km0.png"
import useWindowSize from "../utils";

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "3%",
    },
    bio: {
        display: "flex",
        justifyContent: "center",
        maxWidth: "50px",
        maxHeight: "100px",
        backgroundImage: `url(${bio})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        position: "relative",
        padding: "10%",
    },
    km: {
        display: "flex",
        justifyContent: "center",
        maxWidth: "50px",
        maxHeight: "100px",
        backgroundImage: `url(${km})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        position: "relative",
        padding: "10%",
    }
}));

function Home() {
    const classes = useStyles();
    const { width } = useWindowSize();

    return (
        <div className={classes.root} >
            <HomeDesc />

            <h1 style={width < 550 ? {textAlign: "center"} : {}}>I NOSTRI PRODOTTI SONO</h1>
            <Grid container className={classes.container} 
                style={width < 550 ? {flexDirection: "column"} : {}}>
                <Grid item xs={3} className={classes.bio} >
                </Grid>
                <Grid item xs={4} style={{ display: "flex", justifyContent: "center" }}>
                    <a href="/contacts" >
                        <Button variant="contained" name="SCOPRI PRODOTTI" />
                    </a>
                </Grid>
                <Grid item xs={3} className={classes.km} >
                </Grid>
            </Grid>

            <h1 style={width < 550 ? {textAlign: "center", marginTop: "4%", marginBottom: "0px"} : {marginTop: "4%", marginBottom: "0px"}} >Non esitare a contattarci</h1>
            <p style={width < 550 ? {textAlign: "center"} : {}} >Siamo sempre disponibili a rispondere alle vostre domande</p>
            
            <Grid container className={classes.container} 
                style={width < 550 ? {flexDirection: "column"} : {}}>
                <Grid item xs={3} style={{ display: "flex", justifyContent: "center" }} >
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", margin: "5%" }}>
                        <PhoneIcon style={{ width: "70px", height: "70px", color: "#ffbd2c" }} />
                        <p>Telefono</p>
                        <h2>3496825991</h2>
                    </div>
                </Grid>
                <Grid item xs={4} style={{ display: "flex", justifyContent: "center" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", margin: "5%" }}>
                        <EmailIcon style={{ width: "70px", height: "70px", color: "#ffbd2c" }} />
                        <p>E-mail</p>
                        <h2>roccomorabito95@pec.it</h2>
                    </div>
                </Grid>
                <Grid item xs={3} style={{ display: "flex", justifyContent: "center" }}>
                    <div style={{ display: "flex", flexDirection: "column", textAlign: "center", alignItems: "center", margin: "5%" }}>
                        <AddLocationIcon style={{ width: "70px", height: "70px", color: "#ffbd2c" }} />
                        <p >Indirizzo</p>
                        <h2>Località Mazzacuva, snc, Bova Marina, RC, 89035</h2>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}

export default Home;